// Mock data for Notification Tabs

export const mockRobotState = {
  greeting: 'Hi {first_name}, checking in:',
  counts: {
    automations: 3,
    mentions: 4,
    tasks: 7,
    orders: 6,
  },
};

export const mockAutomations = {
  items: [
    {
      id: 'a1',
      title: 'New Patient Onboarding',
      priority: 'error',
      timeAgo: '10 min ago',
      patientName: 'Sarah Johnson',
      description: 'Insurance verification failed - unable to validate coverage. Please provide alternative insurance details or approve manual override.',
      chatHistory: [
        { type: 'robot', text: 'Start onboarding workflow for Sarah Johnson...' },
        { type: 'robot', text: ['Step 1/5: Collecting patient information...', 'Step 2/5: Verifying insurance coverage...'] },
        { type: 'error', text: 'Insurance verification failed: Policy #INS-4829 not found in carrier database.' },
        { type: 'robot', text: 'I need your help - the insurance policy could not be verified. Would you like me to retry with different details, or should I proceed without insurance verification?' },
      ],
    },
    {
      id: 'a2',
      title: 'Follow-Up Appointment',
      priority: 'error',
      timeAgo: '5 min ago',
      patientName: 'Michael Smith',
      description: 'Appointment confirmed for next week. Ensure patient has all necessary documents ready.',
      chatHistory: [
        { type: 'robot', text: 'Scheduling follow-up appointment for Michael Smith...' },
        { type: 'robot', text: ['Step 1/3: Checking provider availability...', 'Step 2/3: Confirming patient preferences...'] },
        { type: 'error', text: 'Schedule conflict detected: Preferred time slot is unavailable.' },
        { type: 'robot', text: 'The requested time slot is not available. Would you like me to suggest alternative times, or should I override the scheduling conflict?' },
      ],
    },
    {
      id: 'a3',
      title: 'New Patient Onboarding',
      priority: 'error',
      timeAgo: '10 min ago',
      patientName: 'Sarah Johnson',
      description: 'Insurance verification failed - unable to validate coverage. Please provide alternative insurance details or approve manual override.',
      chatHistory: [
        { type: 'robot', text: 'Start onboarding workflow for Sarah Johnson...' },
        { type: 'robot', text: ['Step 1/5: Collecting patient information...', 'Step 2/5: Verifying insurance coverage...'] },
        { type: 'error', text: 'Insurance verification failed: Policy #INS-4829 not found in carrier database.' },
        { type: 'robot', text: 'I need your help - the insurance policy could not be verified. Would you like me to retry with different details, or should I proceed without insurance verification?' },
      ],
    },
    {
      id: 'a4',
      title: 'Follow-Up Appointment',
      priority: 'error',
      timeAgo: '5 min ago',
      patientName: 'Michael Smith',
      description: 'Appointment confirmed for next week. Ensure patient has all necessary documents ready.',
      chatHistory: [
        { type: 'robot', text: 'Scheduling follow-up appointment for Michael Smith...' },
        { type: 'robot', text: ['Step 1/3: Checking provider availability...', 'Step 2/3: Confirming patient preferences...'] },
        { type: 'error', text: 'Schedule conflict detected: Preferred time slot is unavailable.' },
        { type: 'robot', text: 'The requested time slot is not available. Would you like me to suggest alternative times, or should I override the scheduling conflict?' },
      ],
    },
    {
      id: 'a5',
      title: 'Consultation Request',
      priority: 'warning',
      timeAgo: '20 min ago',
      patientName: 'Emily Chen',
      description: 'Request received for diet consultation. Schedule appointment and send intake form.',
      chatHistory: [
        { type: 'robot', text: 'Processing consultation request for Emily Chen...' },
        { type: 'robot', text: ['Step 1/4: Reviewing request details...', 'Step 2/4: Checking consultant availability...'] },
        { type: 'warning', text: 'Consultant schedule is fully booked for the next 2 weeks.' },
        { type: 'robot', text: 'The preferred consultant is unavailable for the next 2 weeks. Would you like me to check alternative consultants or place this on a waitlist?' },
      ],
    },
    {
      id: 'a6',
      title: 'New Patient Onboarding',
      priority: 'warning',
      timeAgo: '10 min ago',
      patientName: 'Sarah Johnson',
      description: 'Insurance verification failed - unable to validate coverage. Please provide alternative insurance details or approve manual override.',
      chatHistory: [
        { type: 'robot', text: 'Start onboarding workflow for Sarah Johnson...' },
        { type: 'robot', text: ['Step 1/5: Collecting patient information...', 'Step 2/5: Verifying insurance coverage...'] },
        { type: 'warning', text: 'Insurance verification failed: Policy #INS-4829 not found in carrier database.' },
        { type: 'robot', text: 'I need your help - the insurance policy could not be verified. Would you like me to retry with different details, or should I proceed without insurance verification?' },
      ],
    },
  ],
  completedItems: [
    {
      id: 'c1',
      title: 'New Patient Onboarding',
      timeAgo: 'Complete 1 hr ago',
      patientName: 'Sarah Johnson',
      description: 'Insurance verification failed - unable to validate coverage. Please provide alternative insurance details or approve manual override.',
    },
    {
      id: 'c2',
      title: 'Follow-Up Appointment',
      timeAgo: 'Complete 1 hr ago',
      patientName: 'Michael Smith',
      description: 'Appointment confirmed for next week. Ensure patient has all necessary documents ready.',
    },
    {
      id: 'c3',
      title: 'Consultation Request',
      timeAgo: 'Complete 1 hr ago',
      patientName: 'Emily Chen',
      description: 'Request received for diet consultation. Schedule appointment and send intake form.',
    },
    {
      id: 'c4',
      title: 'Test Results Notification',
      timeAgo: 'Complete 1 hr ago',
      patientName: 'David Lee',
      description: 'Results are in - patient advised to contact the office for a review.',
    },
  ],
};

export const mockMentions = {
  chat: [
    {
      id: 'm1',
      initials: 'RN',
      name: 'Rachel Nurse',
      isNew: true,
      timeAgo: '10 min ago',
      patientName: 'Emily Davis',
      message: '"...Patient is asking about program modifications. <mention>@You</mention> do we have approval to adjust the meal plan? She says the current plan is too restri..."',
      avatarBg: '#FCDDEC',
      avatarColor: '#EF5DA8',
    },
    {
      id: 'm2',
      initials: 'TP',
      name: 'Tom Parker',
      isNew: true,
      timeAgo: '20 min ago',
      patientName: 'Liam Johnson',
      message: '"...Patient is requesting additional support for anxiety management. <mention>@Everyone</mention> can we provide resources?"',
      avatarBg: '#E1D3F1',
      avatarColor: '#6F4999',
    },
    {
      id: 'm3',
      initials: 'DB',
      name: 'David Brown',
      isNew: true,
      timeAgo: '30 min ago',
      patientName: 'Noah Wilson',
      message: '"...Patient expressed interest in alternative medication options. <mention>@Team</mention> can we discuss possible alternatives?"',
      avatarBg: '#E4F3F5',
      avatarColor: '#1C96AD',
    },
    {
      id: 'm4',
      initials: 'JS',
      name: 'Jessica Smith',
      isNew: true,
      timeAgo: '15 min ago',
      patientName: 'Liam Thompson',
      message: '"...Patient reported significant fatigue and <mention>@You</mention> is looking for lifestyle changes to improve energy levels."',
      avatarBg: '#E8DDB5',
      avatarColor: '#AEA585',
    },
    {
      id: 'm5',
      initials: 'AR',
      name: 'Amy Robinson',
      isNew: true,
      timeAgo: '2 min ago',
      patientName: 'Sophia Martinez',
      message: '"...Patient inquired about dietary supplements for better health. What are the options we can provide? <mention>@You</mention>"',
      avatarBg: '#C6E0B3',
      avatarColor: '#779968',
    },
  ],
  internalNotes: [
    {
      id: 'n1',
      initials: 'JW',
      name: 'James White',
      isNew: true,
      timeAgo: '5 min ago',
      patientName: 'Samuel Lee',
      message: '"...Patient is concerned about medication side effects. <mention>@Team</mention> can we review his current prescriptions?"',
      avatarBg: '#FFE697',
      avatarColor: '#CB9F12',
    },
    {
      id: 'n2',
      initials: 'MK',
      name: 'Megan Kim',
      isNew: true,
      timeAgo: '15 min ago',
      patientName: 'Olivia Brown',
      message: '"...Patient has questions regarding her therapy schedule. <mention>@Group</mention> should we reassess her appointments?"',
      avatarBg: '#C6E0B3',
      avatarColor: '#779968',
    },
    {
      id: 'n3',
      initials: 'AS',
      name: 'Alice Smith',
      isNew: true,
      timeAgo: '25 min ago',
      patientName: 'Sophia Martinez',
      message: '"...Patient is experiencing discomfort with the current treatment. <mention>@Colleagues</mention> should we consult with the specialist?"',
      avatarBg: '#F4D7D4',
      avatarColor: '#D18B84',
    },
    {
      id: 'n4',
      initials: 'MK',
      name: 'Michael Keyes',
      isNew: true,
      timeAgo: '5 min ago',
      patientName: 'Emma Davis',
      message: '"...Patient is interested in integrating physical therapy into their recovery plan. Can we schedule a session? <mention>@You</mention>"',
      avatarBg: '#E0E0E0',
      avatarColor: '#9A9A9A',
    },
    {
      id: 'n5',
      initials: 'LT',
      name: 'Lucas Taylor',
      isNew: true,
      timeAgo: '1 min ago',
      patientName: 'Ethan Johnson',
      message: '"...Patient has shown interest in mental health resources. Can we share available support services? <mention>@You</mention>"',
      avatarBg: '#E1D3F1',
      avatarColor: '#6F4999',
    },
  ],
};

export const mockTasks = {
  items: [
    { id: 't1', completed: false, task: 'Review Lab Results', description: 'Go through pending lab results for recent patie...', dueDate: 'Today, Sep 3, 9am' },
    { id: 't2', completed: true, task: 'Follow-up Calls', description: 'Call back patients with incomplete encounter n...', dueDate: 'Today, Sep 3, 4pm' },
    { id: 't3', completed: false, task: 'Pre-Appointment Chart Review', description: 'N/A', dueDate: 'N/A' },
    { id: 't4', completed: true, task: 'Weekly Team Sync Preparation', description: 'N/A', dueDate: 'N/A' },
    { id: 't5', completed: false, task: 'Update Care Plan Goals', description: "Adjust patient's care plan based on recent pro...", dueDate: 'N/A' },
    { id: 't6', completed: false, task: 'Medication Refill Authorization', description: 'Approve or modify medication refill requests s...', dueDate: 'N/A' },
    { id: 't7', completed: true, task: 'Patient Education Follow-Up', description: 'Send educational materials or schedule a call t...', dueDate: 'Today, Sep 3, 9am' },
    { id: 't8', completed: false, task: 'Insurance Pre-Authorization', description: 'Complete required pre-authorization paperwor...', dueDate: 'N/A' },
    { id: 't9', completed: false, task: 'Specialist Referral Coordination', description: 'Prepare and send referral documentation to sp...', dueDate: 'Wed, Sep 5, 9am' },
    { id: 't10', completed: false, task: 'Medication Management', description: 'Review and adjust patient medications based...', dueDate: 'Thu, Sep 6, 10am' },
  ],
  total: 35,
};

export const mockOrders = {
  items: [
    { id: 'o1', time: '1 min ago', status: 'Report Available', statusType: 'available', providerName: 'JOHN RAJARSERKAREN', patientName: 'JEREMY JOHANSON', accessionId: '2201260172', serviceDate: '06-25-2025', isNew: true },
    { id: 'o2', time: '1 min ago', status: 'Report Amended', statusType: 'amended', providerName: 'JOHN RAJARSERKAREN', patientName: 'JEREMY JOHANSON', accessionId: '2201260172', serviceDate: '06-25-2025', isNew: true },
    { id: 'o3', time: '15 mins ago', status: 'Report Available', statusType: 'available', providerName: 'LUCY FERNANDEZ', patientName: 'BRIAN SMITH', accessionId: '2201260205', serviceDate: '07-05-2025', isNew: false },
    { id: 'o4', time: '20 mins ago', status: 'Report Amended', statusType: 'amended', providerName: 'LUCAS MARTINEZ', patientName: 'MIA GARCIA', accessionId: '2201260176', serviceDate: '06-29-2025', isNew: false },
    { id: 'o5', time: '10 mins ago', status: 'Report Available', statusType: 'available', providerName: 'MIKE GARCIA', patientName: 'SARAH WILSON', accessionId: '2201260194', serviceDate: '07-01-2025', isNew: false },
    { id: 'o6', time: '15 mins ago', status: 'Report Amended', statusType: 'amended', providerName: 'OLIVER BROWN', patientName: 'ISABELLA DAVIS', accessionId: '2201260175', serviceDate: '06-28-2025', isNew: false },
    { id: 'o7', time: '20 mins ago', status: 'Report Available', statusType: 'available', providerName: 'DAVID KIM', patientName: 'EMMA DAVIS', accessionId: '2201260216', serviceDate: '07-10-2025', isNew: false },
  ],
  total: 35,
  newNotificationCount: 8,
};
